import { __assign } from 'tslib';
import React, { forwardRef, useState, useEffect } from 'react';
import cn from 'classnames';
import _debounce from 'lodash/debounce';
import { IconButton } from '../../../../icon-button/esm';
import { ChevronLeftCompactSIcon } from '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import { ChevronRightCompactSIcon } from '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import { getDisabledState, scrollIntoFirstTab, scrollIntoLastTab } from './utils.js';

var styles = {"component":"tabs__component_14wd6","primary":"tabs__primary_14wd6","button":"tabs__button_14wd6","xl":"tabs__xl_14wd6","secondary":"tabs__secondary_14wd6","xs":"tabs__xs_14wd6","borderVisible":"tabs__borderVisible_14wd6"};
require('./index.css');

var ScrollControls = forwardRef(function (_a, ref) {
    var _b;
    var containerRef = _a.containerRef, view = _a.view, sizeProp = _a.size, className = _a.className, showSkeleton = _a.showSkeleton;
    var container = containerRef.current;
    var _c = useState(function () { return getDisabledState(container); }), disabledState = _c[0], updateDisabledState = _c[1];
    useEffect(function () {
        var handleScroll = _debounce(function () { return updateDisabledState(getDisabledState(container)); }, 100, { leading: true, maxWait: 100, trailing: true });
        container === null || container === void 0 ? void 0 : container.addEventListener('scroll', handleScroll);
        return function () { return container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', handleScroll); };
    }, [container]);
    var getSize = function () {
        if (view === 'primary') {
            return sizeProp === 'xl' ? 'xs' : 'xxs';
        }
        return sizeProp && ['s', 'm', 'l', 'xl'].includes(sizeProp) ? 's' : 'xs';
    };
    var handleScrollLeft = function () { return scrollIntoFirstTab(container); };
    var handleScrollRight = function () { return scrollIntoLastTab(container); };
    var commonButtonProps = {
        className: styles.button,
        size: getSize(),
        view: 'secondary',
    };
    return (React.createElement("div", { ref: ref, className: cn(styles.component, styles[view], sizeProp && styles[sizeProp], className, (_b = {},
            _b[styles.borderVisible] = !disabledState.toRight,
            _b)) },
        React.createElement(IconButton, __assign({}, commonButtonProps, { icon: ChevronLeftCompactSIcon, disabled: disabledState.toLeft || showSkeleton, onClick: handleScrollLeft })),
        React.createElement(IconButton, __assign({}, commonButtonProps, { icon: ChevronRightCompactSIcon, disabled: disabledState.toRight || showSkeleton, onClick: handleScrollRight }))));
});
ScrollControls.displayName = 'ScrollControls';

export { ScrollControls };
